import { render, staticRenderFns } from "./clientAddOrUpdate.vue?vue&type=template&id=48170cc2&scoped=true&"
import script from "./clientAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./clientAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48170cc2",
  null
  
)

export default component.exports